"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageRoutes = void 0;
exports.messageRoutes = [
    {
        name: 'message.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'message.for-conversation',
        path: '/for-conversation/:conversationId',
        method: 'GET'
    },
    {
        name: 'message.create',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'message.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'message.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'message.delete',
        path: '/:id',
        method: 'DELETE'
    },
    {
        name: 'message.mark-read',
        path: '/:id/read',
        method: 'POST'
    },
    {
        name: 'message.unread-count',
        path: '/unread-count/:conversationId',
        method: 'GET'
    }
];
